import { OrderStatusResourceTypeMappings } from '@aa/nest/resource';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  BaseFormModalComponent,
  baseFormModalImports,
  FormModalData,
} from '../../components/base-form-modal/base-form-modal.component';
import { CoreAppState } from '../../state/core-app.state';
import { orderStatusActions } from '../../state/order-status/order-status.actions';

// @aa:gen-ignore

export type OrderStatusFormModel = Partial<
  OrderStatusResourceTypeMappings['createDTO']
>;
export type OrderStatusFormModalData = FormModalData<OrderStatusFormModel>;

@Component({
  selector: 'aa-order-status-form-modal',
  standalone: true,
  imports: [...baseFormModalImports],
  templateUrl:
    '../../components/base-form-modal/base-form-modal.component.html',
  styleUrl: '../../components/base-form-modal/base-form-modal.component.scss',
})
export class OrderStatusFormModalComponent extends BaseFormModalComponent<
  OrderStatusFormModel,
  OrderStatusFormModalData
> {
  title = 'Order Status';
  fields: FormlyFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      props: {
        label: 'Name',
        type: 'text',
        required: true,
      },
    },
    {
      fieldGroupClassName: 'flex-row-field-group',
      fieldGroup: [
        {
          key: 'hexColor',
          type: 'input',
          props: {
            label: 'Hex Color',
            type: 'text',
            required: true,
          },
        },
        {
          key: 'hexColor',
          type: 'input',
          props: {
            label: 'Color Picker',
            type: 'color',
            required: true,
          },
        },
      ],
    },
  ];

  createAction = orderStatusActions.createItem;
  updateAction = orderStatusActions.updateItem;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    protected override readonly data: OrderStatusFormModalData,
    protected override readonly dialogRef: MatDialogRef<OrderStatusFormModalComponent>,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(data, dialogRef, store);
  }
}
